import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { TaskSubmission } from "@/types/taskSubmissionTypes"

export const useMakeAllFeedbacksRead = (id?: number) => {
  //✅
  return useGenericQuery<never>({
    keys: QUERY_KEYS.feedbacks.makeAllReadById(id!),
    apiEndpoint: ENDPOINTS.feedbacks.makeAllReadById(id!),
    enabled: !!id,
  })
}
export const useFeedbacksCount = () => {
  //✅
  return useGenericQuery<{ unReadFeedbacks: number }>({
    keys: QUERY_KEYS.feedbacks.counts(),
    apiEndpoint: ENDPOINTS.feedbacks.counts(),
  })
}
export const useAllFeedbacksData = () => {
  // ✅
  return useGenericQuery<TaskSubmission[]>({
    keys: QUERY_KEYS.feedbacks.all(),
    apiEndpoint: ENDPOINTS.feedbacks.all(),
    paginated: true,
  })
}
